import { useState } from 'react'
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace'
import styles from './BackButton.module.scss'
import ConfirmDialog from '../Dialog/ConfirmDialog'
import CONSTANTS from '../../../Constants'
import { ISaveDraftCallback } from '../../../Models/CategoryFormData'
import { layoutIdInSessionStorage } from '../../../Helpers/Util'
import UnsavedPopup from '../UnsavedPopup'

interface BackButtonProps {
  className?: string
  handleOnClick?: any
  label?: string
  isFormUpdated?: boolean
  saveDraftCallback?: ISaveDraftCallback
}

const BackButton = ({
  className,
  handleOnClick,
  label,
  isFormUpdated,
  saveDraftCallback,
}: BackButtonProps) => {
  const [openDialog, setOpenDialog] = useState(false)

  const handleCategorySelection = () => {
    if (isFormUpdated) {
      setOpenDialog(true)
    } else {
      handleOnClick()
    }
  }

  return (
    <>
      <UnsavedPopup
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        onConfirm={async () => {
          await saveDraftCallback?.()
        }}
        onCloseDialog={() => {
          layoutIdInSessionStorage('remove')
          handleOnClick()
        }}
      />
      <div
        className={`${styles.backBtnWrapper} back-btn ${className}`}
        data-testid='backBtnWrapper'
      >
        <div
          data-testid='t-click-btn'
          className={`${styles.leftAerrow}`}
          onClick={handleCategorySelection}
        >
          <KeyboardBackspaceIcon />
        </div>
        <p className={`${className} capitalize`}>{label}</p>
      </div>
    </>
  )
}

export default BackButton
